(function () {
  'use strict';

  if (window.__preorderInit) return;
  window.__preorderInit = true;

  // product.variants|json omits inventory_policy and inventory_quantity, so we
  // read the Liquid-computed per-variant preorder lookup baked into buy-buttons.liquid.
  function getPreorderData(sectionId) {
    var el = document.getElementById('preorder-data-' + sectionId);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function isPreorder(variantId, sectionId) {
    var data = getPreorderData(sectionId);
    return !!(data && data.variants && data.variants[variantId] === true);
  }

  function updatePreorderUI(sectionId, variant) {
    var preorder = isPreorder(variant && variant.id, sectionId);

    // Ship date line
    var shipDateEl = document.getElementById('preorder-ship-date-' + sectionId);
    if (shipDateEl) {
      shipDateEl.hidden = !preorder;
    }

    // Cart line item property — disabled inputs are not submitted
    var propInput = document.getElementById('preorder-prop-' + sectionId);
    if (propInput) {
      propInput.disabled = !preorder;
    }
  }

  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data) return;
      updatePreorderUI(event.data.sectionId, event.data.variant);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
